import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { LinkIconButton } from "../../components/button/LinkIconButton";
import CustomContainer from "../../components/CustomContainer";
import ModalForm from "../../components/form/ModalForm";
import Loader from "../../components/Loader";
import CardTable from "../../components/table/CardTable";
import { useModels } from "../../helpers/models";
import columns from "./config/FormatTableConfig";
import SatFormConfig from "./config/SatFormConfig";

const FormatTablePage = (props) => {

    const { t } = useTranslation();
    const [loader, setLoader] = useState(false);
    const [satDetails, setSatDetails] = useState();
    const models = useModels();

    return (
        <>
            <Loader loader={loader}/>
            <CustomContainer title={t("menu.formats")}
                             
                             parent={
                                 <LinkIconButton
                                     model={models.format}
                                     props={props}
                                 />
                             }
            >


                <CardTable
                    title={t("common.formats_list")}
                    source={"format/status-not-in?statuses=WITHDRAWN"}
                    columns={columns(undefined, undefined, setSatDetails, t)}
                    width={12}
                    setLoader={setLoader}
                    striped={false}
                    shadow={true}
                />
            </CustomContainer>
            {satDetails &&
                <ModalForm

                    open={!!satDetails}
                    setOpen={setSatDetails}
                    shadow={false}
                    fields={SatFormConfig}
                    setLoader={props.setLoader}
                    initialData={satDetails}
                    readOnly={true}
                    title={t("forms.sat_details")}
                    size={"md"}
                />
            }
        </>
    );
};

export default FormatTablePage;
